class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', this.isOpen());
    this.detailsContainer.addEventListener('toggle', () => {
      this.summaryToggle.setAttribute('aria-expanded', this.isOpen());
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen()
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (event === this.openingEvent) return;
    const inside = event.composedPath().includes(this);
    if (!inside || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if (this.isOpen()) return;
    this.openingEvent = event;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', '');
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    this.closest('sticky-header')?.reveal?.();
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;
    this.openingEvent = null;
    this.querySelector('predictive-search')?.close?.();
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);

  }
  disconnectedCallback() {
    if (this.isOpen()) removeTrapFocus();
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }
}

if (!customElements.get('details-modal')) customElements.define('details-modal', DetailsModal);
